import { LayoutDashboard, Smartphone, Building2, Palette, Camera, Mail, Check } from "lucide-react";
import { Reveal, SectionHead } from "./Section";
import { IMG } from "./homeData";

const OFFICE = ["Dispatch jobs with address lookup and scheduled dates", "Weekly rosters with casual accept or decline", "Timesheets, pay approvals and payroll PDFs", "Branded job reports emailed to your clients"];
const CREW = ["Installs from the browser — no app store", "Alerts for new jobs and shifts", "One-tap clock on and off, with breaks", "Before, after and issue photos from site"];
const SMALL = [
  [Building2, "Multi-depot", "Separate jobs, clients and payroll per depot, with one shared crew."],
  [Palette, "Fully customisable", "Pay period and start day, state, payroll email, logo, colours and ABN — set per company."],
  [Camera, "Site photos", "Captioned before, after and issue photos on every job."],
  [Mail, "Bookkeeper-ready", "Payroll PDF emailed in one click, every pay period."],
];

const List = ({ items, dark }) => (
  <ul className="mt-6 space-y-3">
    {items.map((t) => (
      <li key={t} className={`flex gap-3 text-sm sm:text-base ${dark ? "text-slate-200" : "text-slate-700"}`}>
        <span className="mt-0.5 w-5 h-5 shrink-0 rounded-full bg-[#EA580C] text-white grid place-items-center"><Check className="w-3 h-3" /></span>{t}
      </li>
    ))}
  </ul>
);

export const Features = () => (
  <section id="features" className="scroll-mt-16 bg-[#F8FAFC] home-grid-light py-24 lg:py-32" data-testid="home-features">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <SectionHead num="02" eyebrow="Features" title={<>Everything the office needs.<br />Nothing the crew has to learn.</>}
        sub="One dashboard for supervisors, one simple phone app for workers — and every hour, photo and shift lands in the same place." />
      <div className="mt-16 grid lg:grid-cols-6 gap-5">
        <Reveal className="lg:col-span-3 rounded-2xl bg-[#1E3A5F] text-white p-8 sm:p-10 relative overflow-hidden" >
          <div data-testid="home-feature-office">
            <LayoutDashboard className="w-9 h-9 text-[#EA580C]" />
            <h3 className="font-display mt-5 text-2xl sm:text-3xl font-bold tracking-tight">Supervisor dashboard</h3>
            <p className="mt-2 text-slate-300">Run every depot from a desktop or tablet.</p>
            <List items={OFFICE} dark />
          </div>
          <div className="absolute -right-10 -bottom-10 w-48 h-48 rounded-full border-[18px] border-white/5" />
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-3 rounded-2xl overflow-hidden bg-white border border-slate-200 grid sm:grid-cols-2">
          <div className="p-8 sm:p-10" data-testid="home-feature-crew">
            <Smartphone className="w-9 h-9 text-[#EA580C]" />
            <h3 className="font-display mt-5 text-2xl sm:text-3xl font-bold tracking-tight">Worker phone app</h3>
            <List items={CREW} />
          </div>
          <div className="min-h-[240px] bg-cover bg-center" style={{ backgroundImage: `url(${IMG.tradie})` }} role="img" aria-label="Melbourne tradie in hi-vis on site" />
        </Reveal>
        {SMALL.map(([Icon, title, text], i) => (
          <Reveal key={title} delay={0.06 * i} className={`${i < 2 ? "lg:col-span-3 xl:col-span-3" : "lg:col-span-3"} sm:col-span-1`}>
            <div className="h-full rounded-2xl bg-white border border-slate-200 p-7 flex gap-5 hover:border-[#EA580C]/60 transition-colors" data-testid={`home-feature-${i}`}>
              <span className="w-12 h-12 shrink-0 rounded-xl bg-[#FFEDD5] text-[#9A3412] grid place-items-center"><Icon className="w-6 h-6" /></span>
              <div><h4 className="font-display text-lg sm:text-xl font-bold">{title}</h4><p className="mt-1 text-slate-600">{text}</p></div>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
